<template>
  <section
    v-if="sliders && sliders.length"
    class="py-4 custom-container"
    id="HeaderBanner"
  >
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div
          v-for="slider in sliders"
          :key="slider.id"
          class="w-100 h-100 border-r-10 overflow-hidden swiper-slide custome-aspect-ratio"
        >
          <DynamicLinker class="d-inline-block w-100 h-100" :item="slider">
            <img
              :src="slider.image.url"
              class="w-100 h-100"
              :alt="slider.title"
            />
          </DynamicLinker>
        </div>
        <!-- <div
          v-for="slider in sliders"
          :key="slider.id"
          class="row align-items-center justify-content-between m-0 flex-column-reverse py-0 py-lg-3 px-0 px-lg-3 flex-lg-row swiper-slide"
        >
          <div
            class="col-12 col-lg-5 p-0 mt-4 mt-lg-0 d-none d-lg-block content-container"
          >
            <template v-if="slider.title && slider.title.includes('-')">
              <h2 class="font-w-900 text-color-theme font-s-44">
                {{ slider.title.slice(0, slider.title.indexOf("-")) }}
              </h2>
              <h3 class="font-w-900 text-color-theme-dark font-s-44">
                {{
                  slider.title.slice(
                    slider.title.indexOf("-") + 1,
                    slider.title.length
                  )
                }}
              </h3>
            </template>
            <template v-else>
              <h2 class="font-w-900 text-color-theme font-s-44">
                {{ slider.title }}
              </h2>
            </template>

            <p class="font-w-400 font-s-14 text-color-theme-dark">
              {{ slider.description }}
            </p>
            <button
              type="button"
              class="custom-btn"
              data-toggle="modal"
              data-target="#loginModal"
            >
              ورود / عضویت
            </button>
          </div>
          <div class="col-12 col-lg-6 p-0 image-container">
            <DynamicLinker class="d-inline-block w-100 h-100" :item="slider">
              <img
                :src="slider.image.url"
                class="w-100 h-100"
                :alt="slider.title"
              />
            </DynamicLinker>
          </div>
        </div> -->
      </div>
    </div>
  </section>
</template>
<script>
import Swiper from "swiper/swiper-bundle.min.js";
import DynamicLinker from "@/parts/Front/components/shared/DynamicLinker";
import findUrl from "@/libraries/links/LinkResolver";

export default {
  name: "homeSlider",
  components: { DynamicLinker },
  inject: ["mediaQueries"],
  methods: {
    findUrl,
    initHeaderSwiper(kill = false) {
      this.initSwiper("slider-swiper", kill, () => {
        try {
          if (this.slider) {
            this.slider.destroy();
          }
        } catch (e) {}
        this.slider = new Swiper("#HeaderBanner .swiper-container", {
          spaceBetween: 20,
          slidesPerView: 1,
          speed: 1500,
          loop: false,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false,
          },
        });
      });
    },
  },
  mounted() {
    this.$store.dispatch("front/getIndexSlider");
    this.initHeaderSwiper();
  },
  watch: {
    sliders() {
      this.initHeaderSwiper(true);
    },
  },
  computed: {
    sliders() {
      let slidersData = this.$store.getters["front/getSliderIndex"];
      if (slidersData) {
        let sliders;
        if (this.mediaQueries.medium) {
          sliders = slidersData.sliders.filter((s) =>
            s.group.includes("mobile")
          );
        } else {
          sliders = slidersData.sliders.filter(
            (s) => !s.group.includes("mobile")
          );
        }
        return sliders;
      } else {
        return null;
      }
    },
  },
};
</script>
<style scoped>
.custome-aspect-ratio {
  aspect-ratio: 2.35/1;
}
@media screen and (max-width: 768px) {
 .custome-aspect-ratio {
    aspect-ratio: 1.91/1;
  }
}
</style>
